const dataplusNewDataPermissions = (
  action,
  permissions,
  institutionId,
  year,
) => {
  if (
    action === 'dataplusNewData:viewPage' &&
    permissions[institutionId].includes(`DATAPLUS_NEW_DATA_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  dataplusNewDataPermissions,
};
